import ActionCreator from "../actionCreator";

export default {
    samlValidate: ActionCreator("AUTH_SAML_VALIDATE"),
    login: ActionCreator("LOGIN"),
    checkStorage: ActionCreator("CHECK_STORAGE"),
    restoreUser: ActionCreator("AUTH_RESTORE_USER"),
    getCurrentUser: ActionCreator("GET_CURRENT_USER"),
    updateCurrentUser: ActionCreator("UPDATE_CURRENT_USER"),
    setAuth: ActionCreator("AUTH_SET_AUTH"),
    setNotAuth: ActionCreator("SET_NOT_AUTH"),
    logout: ActionCreator("LOGOUT"),
    errorResponse: ActionCreator("ERROR_RESPONSE"),
    setInitiated: ActionCreator("AUTH_SET_INITIATED"),
    interactiveLogin: ActionCreator("AUTH_INTERACTIVE_LOGIN"),
    setMasqueraded: ActionCreator("SET_MASQUARADED"),
    logoutMasquaraded: ActionCreator("SET_LOGOUT_MASQUARADED"),
    loginMasquaraded: ActionCreator("SET_LOGIN_MASQUARADED"),
    clearAllReducers: ActionCreator("AUTH_CLEAR_ALL_REDUCERS"),
};
